import { Module } from "vuex";
import { userManagementGetters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { TourState } from "./types";
import { RootState } from "@/store/types";
import { getDefaultState } from "./state";

export const state: TourState = getDefaultState();

const namespaced: boolean = true;

export const tours: Module<TourState, RootState> = {
	namespaced,
	state,
	getters: userManagementGetters,
	actions,
	mutations
};